module.exports = __webpack_public_path__ + "static/media/CC-COL12_1KYEkU4-w3ca9aRvpCmoumEmAyxf5zvlJ.3441dbfa.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/CC-COL12_1KYEkU4-w3ca9aRvpCmoumEmAyxf5zvlJ
// module id = 772
// module chunks = 0